export default () => {
    const sectionHashes = [...document.querySelectorAll('.js-clipBoard')]

    if (sectionHashes.length) {
        sectionHashes.forEach(sectionHash => {
            // eslint-disable-next-line no-undef
            const tippyLink = tippy(sectionHash, {
                content: 'Copy Section Hash',
            })

            sectionHash.addEventListener('click', e => {
                e.preventDefault()
                navigator.clipboard.writeText(sectionHash.href)
                tippyLink.setContent('Copied to clipboard!')
                tippyLink.show()
                setTimeout(() => {
                    tippyLink.hide()
                    tippyLink.setContent('Copy Section Hash')
                }, 2000)
            })
        })
    }
}
